<template>
	<div class="con-1334 box-white mt-30px">
		<div v-if="!noStatements" class="section__wrapper con-1060">
			<h3 class="section__title">Az épület állapota</h3>
			<div class="section">
				<div class="section__text">
					Csak olyan, az ingatlan-nyilvántartásban feltüntetett épületre köthető biztosítás, amely a
					biztosítás szempontjából megfelelő állapotú. Nem megfelelő állapotú épületre a biztosító nem vállal
					kockázatot.
					<br />
					Nem megfelelő állapotú az épület, ha:
					<ul>
						<li>
							az épület rendeltetésszerű használatra alkalmatlan és jól láthatóan nem karbantartott, vagy
						</li>
						<li>
							állékonysági, tűzvédelmi, egészségvédelmi szempontból elégtelen állapotú épületrészeket,
							szerkezeteket, berendezéseket tartalmaz, vagy
						</li>
						<li>az épület műszaki állapota és berendezései veszélyeztetik az épület használóit, vagy</li>
						<li>
							a teherhordó szerkezeteken olyan elváltozás található (repedés, szerkezeti hiány), amely az
							épület állékonyságára kihatással van, vagy
						</li>
						<li>
							a falazat strukturájának megbomlása megkezdődott, jelentős dőlés, süllyedés észlelhető, vagy
						</li>
						<li>
							a falazat vizszigetelése hiányzik, vagy már nem tölti be a funkciójat, emiatt felázás
							tapasztalható, vagy
						</li>
						<li>
							a lakott épületrészek külső falazata, nyílászárói és tetőfedése nem alkotnak zárt egységet,
							vagy
						</li>
						<li>
							a tető rossz általános állapotú, a tető valamely fő alkotórészének (pl. váz, cseréplécek,
							tetőfedés) anyaga élettartamának végéhez ért, a tető strukturája megbomlott, vagy
						</li>
						<li>
							az épületre vagy egyes részeire, berendezéseire bármilyen hatóság olyan határozatot hozott,
							amely a működését, használatát korlátozza vagy megtiltja.
						</li>
					</ul>
				</div>
				<div class="section__checkbox">
					<CalcElem
						name="buildingStatus"
						:options="{
							label: 'Az épület állapota megfelelő.',
							type: 'checkbox',
							wrapperClass: 'col-w100-chbox chbox_style-wrapper',
							inputClass: 'w-100 mobile-width-full d-flex items-center justify-center',
							className: 'mw-500px',
							prop: 'buildingStatus',
						}"
						type="contracting"
					/>
					<span class="error_message error_message--broke" v-if="errors.buildingStatus">
						{{ errors.buildingStatus }}
					</span>
				</div>
				<!-- <div class="section__extend" @click="handleExtend">
            Részletek <span>{{ !buildingStatusExtended ? '⌄' : '⌃'}}</span>
        </div> -->
			</div>
		</div>
		<div v-if="!noStatements" class="section__wrapper con-1060">
			<h3 class="section__title">Kifizetett károk</h3>
			<div class="section">
				<div class="section__text flexi">
					<CalcElem
						name="damageCount"
						:options="{
							rules: 'required',
							type: 'text',
							label: 'Előző 3 évben kifizetett károk száma',
							unit: 'db',
							sidebar: true,
							inputClass: 'mw-500px mobile-width-full',
							wrapperClass: 'mobile-width-full',
						}"
						class="mw-500px mobile-width-full"
						type="contracting"
					/>
					<CalcElem
						name="damageAmount"
						:options="{
							rules: '',
							type: 'text',
							label: 'Előző 3 évben kifizetett károk összege',
							unit: 'Ft',
							sidebar: true,
							inputClass: 'mw-500px mobile-width-full',
							wrapperClass: 'mobile-width-full',
							format: true,
						}"
						class="mw-500px mobile-width-full"
						type="contracting"
					/>
				</div>
			</div>
		</div>
		<h3 v-if="!noStatements" class="section__title">Nyilatkozatok</h3>
		<SectionBox
            v-if="!noStatements"
			v-for="(statement, index) in statements"
			:key="index"
			:text="statement.text"
			:description="statement.description !== undefined ? statement.description : null"
			:prop="index"
			:ref="`section-${index}`"
			insurer="GEN"
			:label="statement.label"
		/>
        <div class="section__wrapper con-1060" v-if="euroriskMarketing">
            <div class="section__text"><b>Eurorisk Marketing nyilatkozat:</b></div>
            <CalcElem
                name="euroriskMarketing"
                :options="{
							label: 'Igen',
							type: 'yes-no-checkbox',
							wrapperClass: 'col-w100-chbox chbox_style-wrapper',
							inputClass: 'w-100 mobile-width-full d-flex items-center justify-center',
							className: 'mw-500px',
							prop: 'euroriskMarketing',
						}"
                type="contracting"
            />
        </div>
		<div class="section__wrapper con-1200" v-if="!noContract">
			<h3 class="section__title">Alkuszi megbízás</h3>
			<div class="section">
				<div class="section__text text-center" v-if="!noStatements">
					Kérjük, töltse le az Alkuszi megbízás+Igényfelmérő+Biztosítás közvetítői elemzés, a Biztosítási
					feltételek, valamint az Eurorisk ÁSZF nevű dokumentumokat, majd szíveskedjen áttanulmányozni és
					megismerni a szerződés megkötésére vonatkozó feltételeket és nyilatkozatokat. Biztosítási
					szerződésének megkötésére ezt követően van lehetőség.
				</div>
                <div class="section__text text-center" v-if="noStatements">
                    Kérjük, töltse le az Alkuszi megbízás+Igényfelmérő+Biztosítás közvetítői elemzés és a Biztosítási
                    feltételek, nevű dokumentumokat, majd szíveskedjen áttanulmányozni és
                    megismerni a szerződés megkötésére vonatkozó feltételeket és nyilatkozatokat. Biztosítási
                    szerződésének megkötésére ezt követően van lehetőség.
                </div>
				<div class="section__files">
					<FileButton
						v-for="(file, index) in files"
						:key="index"
						:name="file.title"
                        :type="file.type"
						:link="computedLinks[index]"
						@clicked="file.clicked = true"
					/>
				</div>
				<div class="section__checkbox section__checkbox--center" v-if="!downloadNotRequired">
					<CalcElem
						name="allFilesAccepted"
						:options="{
							label: 'Az ajánlat tartalmát ellenőriztem, a mellékelt tájékoztatókat és feltételeket megértettem, ez alapján a kiválasztott biztosítási szerződés megkötésére alkuszi megbízást adok az Eurorisk Kft-nek.',
							type: 'checkbox',
							wrapperClass: 'col-w100-chbox chbox_style-wrapper',
							className: 'mw-500px',
							prop: 'allFilesAccepted',
						}"
						type="contracting"
						class="checkbox-center"
						:disabled="isDisabled"
						@click="handleAllFilesAcceptedClick()"
					/>
					<span class="error_message error_message--broke" v-if="errors.allFilesAccepted">
						{{ errors.allFilesAccepted }}
					</span>
				</div>
                <div class="section__checkbox section__checkbox--center" v-if="privacyRequired">
                    <CalcElem
                        name="privacyAccept"
                        :options="{
                            label: 'Az Eurorisk Kft. <a href=\'/adatvedelem\' target=\'_blank\'>adatkezelési tájékoztatóját</a> elolvastam és megértettem.',
							type: 'checkbox',
							wrapperClass: 'col-w100-chbox chbox_style-wrapper',
							className: 'mw-500px',
							prop: 'privacyAccept',
						}"
                        type="contracting"
                        class="checkbox-center"
                    />
                    <span class="error_message error_message--broke" v-if="errors.privacyAccept">
						{{ errors.privacyAccept }}
					</span>
                </div>
                <div class="section__checkbox section__checkbox--center" v-if="!computedIsNewContract">
                    <CalcElem
                        name="terminationAuthorizationAccepted"
                        :options="{
							label: 'A jelenlegi lakásbiztosítási szerződésem felmondására megbízást adok az Eurorisk Kft.-nek.',
							type: 'checkbox',
							wrapperClass: 'col-w100-chbox chbox_style-wrapper',
							className: 'mw-500px',
							prop: 'terminationAuthorizationAccepted',
						}"
                        type="contracting"
                        class="checkbox-center"
                        @click="handleAllFilesAcceptedClick()"
                    />
                    <span class="error_message error_message--broke" v-if="errors.terminationAuthorizationAccepted">
						{{ errors.terminationAuthorizationAccepted }}
					</span>
                </div>
			</div>
		</div>
		<div class="con-1200 bottom-info" v-if="!downloadNotRequired">
			A Megkötöm gomb megnyomásával biztosítási ajánlatot tesz a Biztosító részére. Amennyiben a Biztosító az
			ajánlatot nem utasítje el, a biztosítási szerződés létrejön.
			<br />
			A létrejött szerződés alapján a szerződő felet díjfizetési kötelezettség terheli.
		</div>
	</div>
</template>

<script>
import statements from '@json/contracting/generali/statements.json';
import statementData from '@/mixins/statementData';

export default {
    created() {
        if(this.allChecked){
            this.checkboxes.forEach(statement => {
                const parts = statement.split('.');
                this.setCheckboxData({ group:'statements', insurer:parts[0], prop:parts[1], value:true });
            });
        }

        if(this.downloadNotRequired) {
            this.setCheckboxData({ prop:'allFilesAccepted', value:true });
        }
    },
	mixins: [statementData],
    props: {
        noContract: {type: Boolean, default: false},
        downloadNotRequired: {type: Boolean, default: false},
        allChecked: {type: Boolean, default: false},
        noStatements: {type: Boolean, default: false},
        privacyRequired: {type: Boolean, default: false},
        euroriskMarketing: {type: Boolean, default: false},
    },
	data() {
		return {
			aszf_link: 'generali/aszf',
			checkboxes: [
				'GEN.ESZAMLA.canFalse',
				'GEN.DOK1.required',
				'GEN.DOK2.required',
				'GEN.DOK3.required',
				'GEN.DOK4.required',
				'GEN.KOZVNY.required',
				'GEN.DOK5.required',
				'GEN.MARKETING.canFalse',
			],
			statements: statements,
			buildingStatusExtended: false,
			firstClick: false,
		};
	},
	methods: {
		handleExtend() {
			this.buildingStatusExtended = !this.buildingStatusExtended;
			this.firstClick = true;
		},
	},
};
</script>

<style lang="scss" scoped>
.section__title {
	text-align: center;
}

.con-1334 {
	padding: 30px 10px;
}

.bottom-info {
	font-family: Arial;
	font-style: italic;
	font-weight: normal;
	font-size: 12px;
	line-height: 18px;
	text-align: center;
	color: #1f2835;
}

@media only screen and (max-width: 1100px) {
	.con-1334 {
		padding: 15px;
	}

	.checkbox-center {
		display: flex;
		justify-content: center;
	}
}

.section {
	&__text {
		font-family: Arial;
		font-style: normal;
		font-weight: normal;
		font-size: 16px;
		line-height: 24px;
		color: #1f2835;

		&.flexi {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;

			@media screen and (max-width: 575px) {
				flex-wrap: wrap;
			}

			.rows {
				width: 50%;

				@media screen and (max-width: 575px) {
					width: 100%;
				}

				.input-label {
					text-align: left !important;
					margin-bottom: 10px;
				}
			}
		}
	}

	&__checkbox {
		margin: 15px 0;

		&--center {
			max-width: 700px;
			margin: 45px auto 40px auto;
		}
	}

	&__files {
		display: flex;
		justify-content: center;
		margin-top: 30px;

		@media only screen and (max-width: 1100px) {
			flex-direction: column;
			align-items: center;

			.file-button {
				margin: 10px;
			}
		}
	}
}
</style>
